import { render, staticRenderFns } from "./editar-usuario.vue?vue&type=template&id=3b872082&scoped=true&"
import script from "./editar-usuario.vue?vue&type=script&lang=js&"
export * from "./editar-usuario.vue?vue&type=script&lang=js&"
import style0 from "./editar-usuario.vue?vue&type=style&index=0&id=3b872082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b872082",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b872082')) {
      api.createRecord('3b872082', component.options)
    } else {
      api.reload('3b872082', component.options)
    }
    module.hot.accept("./editar-usuario.vue?vue&type=template&id=3b872082&scoped=true&", function () {
      api.rerender('3b872082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/editarUsuario/editar-usuario.vue"
export default component.exports